import gql from 'graphql-tag';

export const audioTrackQuery = gql`
  query ($slug: ID!) {
    audioTrack(id: $slug, idType: SLUG) {
      __typename
      content
      databaseId
      duration
      excerpt
      featuredImage {
        node {
          altText
          description
          mediaDetails {
            height
            width
          }
          sourceUrl
        }
      }
      featuredImageWidth
      imageSrcset
      fileUrl
      scApiUrl
      scCreatedAt
      tags {
        nodes {
          name
          slug
        }
      }
      title
      useMp3
    }
  }
`;
